import { List } from "@epcnetwork/core-ui-kit";

import { apiMiddleware } from "../api.middleware";
import { RolesModel } from "models";

export const getRoles = apiMiddleware<List<RolesModel>>()({
  method: "get",
  endpoint: `/roles`,
});
